import CustomerOrderPaymentStatusBadge from 'domains/customer-order/atoms/payment-status-badge'
import PropTypes from 'prop-types'
import { CardHeader, UncontrolledCollapse, UncontrolledTooltip, Table, InputGroup, Input, InputGroupAddon, Button } from 'reactstrap'
import TimeUtil from 'utils/time-util'
import StringUtil from 'utils/string-util'


const propTypes = {
  customerOrderPayment: PropTypes.object
}


/**
 * Multi-purpose Customer Order Payment view.
 * It display about the order item information
 * @param {object} customerOrderPayment
 */
const CustomerOrderPaymentView = ({ customerOrderPayment }) => {
  const showPaymentRedirectUrl = !!customerOrderPayment.redirect_url

  /**
   * Copies the payment redirect_url to the clipboard and displays an alert.
   * This function will help ops to copy link like payment-link from midtrans payment
   */
  const copyPaymentRedirectUrl = () => {
    navigator.clipboard
      .writeText(customerOrderPayment.redirect_url)
      .then(() => { alert('Link Copied') })
  }

  return (
    <>
      <div className='p-3'>
        <div className='small text-uppercase text-light font-weight-bolder'>
          { 'Customer Order Payment' }
        </div>

        <div className='d-flex justify-content-between align-items-center'>
          <h3 className='mb-0'>{ customerOrderPayment.payment_method_name }</h3>
          <small><CustomerOrderPaymentStatusBadge status={ customerOrderPayment.status } /></small>
        </div>
      </div>

      <Table
        bordered
        hover
        size={ 'sm' }
        className='mb-0'
      >
        <tbody>
          <tr>
            <th scope='row'>ID</th>
            <td>{ customerOrderPayment.id }</td>
          </tr>
          <tr>
            <th scope='row'>Order Number</th>
            <td>{ customerOrderPayment.order_number }</td>
          </tr>
          <tr>
            <th scope='row'>Payment Method Name</th>
            <td>{ customerOrderPayment.payment_method_name }</td>
          </tr>
          <tr>
            <th scope='row'>Payment Method Transaction No.</th>
            <td>{ customerOrderPayment.payment_method_transaction_no || '-' }</td>
          </tr>
          <tr>
            <th scope='row'>Amount</th>
            <td>{ StringUtil.currencyCase(customerOrderPayment.amount) }</td>
          </tr>
          <tr>
            <th scope='row'>Created At</th>
            <td>{ TimeUtil.format(customerOrderPayment.created_at) }</td>
          </tr>
          <tr>
            <th scope='row'>Redirect Url</th>
            <td>
              {
                showPaymentRedirectUrl && (
                  <InputGroup>
                    <Input
                      name={ 'reset-password-link' }
                      type='text'
                      value={ customerOrderPayment.redirect_url  }
                    />
                    <InputGroupAddon addonType="append">
                      <Button
                        size='md'
                        outline color='primary'
                        onClick={ copyPaymentRedirectUrl }
                      >
                        <i className='fas fa-copy'/>
                      </Button>
                    </InputGroupAddon>
                  </InputGroup>
                )
              }
            </td>
          </tr>
        </tbody>
      </Table>

      {
        /** Payment method Response (from third party) */
        customerOrderPayment.payment_method_response
          ? (
            <div className='accordion'>
              <CardHeader role="tab" id={ `customer-order-payment-${customerOrderPayment.id}` }>
                <div className='d-flex justify-content-between align-items-center'>

                  <h5 className="mb-0">
                    Payment Method Response
                    <span
                      className='ml-2'
                      id={ `payment-method-response-${customerOrderPayment.id}` }
                    >
                      <i className="fas fa-info-circle 3x" />
                    </span>
                  </h5>

                  <UncontrolledTooltip target={ `payment-method-response-${customerOrderPayment.id}` }>
                    { 'Payment response from the Payment Gateway' }
                  </UncontrolledTooltip>
                </div>
              </CardHeader>

              <UncontrolledCollapse toggler={ `customer-order-payment-${customerOrderPayment.id}` }>
                <Table bordered size={ 'sm' }className='mb-0'>
                  <tbody>
                    {
                      Object.keys(customerOrderPayment.payment_method_response).map((response, index) => (
                        <tr key={ index }>
                          <th scope='row'>{ StringUtil.humanize(response) }</th>
                          <td className='text-wrap'>{ JSON.stringify(customerOrderPayment.payment_method_response[response]) }</td>
                        </tr>
                      ))
                    }
                  </tbody>
                </Table>
              </UncontrolledCollapse>
            </div>
          )
          : null
      }
    </>
  )
}

CustomerOrderPaymentView.propTypes = propTypes

export default CustomerOrderPaymentView
